export const gradientShaders = {
    inject: {
        'fs:#decl': `
      uniform float coef;
      uniform float trailLength;
    `,
        'gl_FragColor = vColor;': `
    float progress = vPathPosition.y / vPathLength;
    float trailRatio = trailLength / vPathLength;
    float vTime = progress * (1.0 - trailRatio);

    float alpha = 0.2;
    if(vTime > coef) discard;
    if(vTime > coef - trailRatio)
     alpha = (vTime - coef + trailRatio) / trailRatio * (1.0 - alpha) + alpha;

    gl_FragColor.a *= alpha;
    `,
    },
};
export const dashAnimationShaders = {
    inject: {
        'vs:#decl': `
  attribute vec2 instanceDashArrays;
  varying vec2 vDashArray;
  varying float currentProgress;

  `,
        'vs:#main-end': `
  vDashArray = instanceDashArrays;
  currentProgress = vPathPosition.y / vPathLength;
  `,
        'fs:#decl': `
  uniform float dashAlignMode;
  uniform float coef;
  varying vec2 vDashArray;
  varying float currentProgress;

  // neg numbers

  float mod2(float a, float b) {
    return a - floor(a / b) * b;
  }

  float round(float x) {
    return floor(x + 0.5);
  }
  `,
        'fs:#main-start': `
    float solidLength = vDashArray.x;
    float gapLength = vDashArray.y;
    float unitLength = solidLength + gapLength;

    if (unitLength > 0.0) {

      if (
        gapLength > 0.0 &&
        vPathPosition.y >= 0.0 &&
        vPathPosition.y <= vPathLength &&
        mod2(vPathPosition.y, unitLength) > solidLength
      ) {
        discard;
      }

    }
  `,
        'gl_FragColor = vColor;': 'if(currentProgress > coef) discard;',
    },
};
